import { Header } from '@/components/header'
import { getMeterSizeRates } from '@/lib/api/meter'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { AddMeterSizeRates } from './add'
import React from 'react'
import { DataTable } from '@/components/data-table'
import { meterSizeRatesColumns } from '@/components/table/columns/meter-size-rates-columns'
import { Button } from '@/components/ui/button'
import { useReactToPrint } from 'react-to-print'
import { Icons } from '@/components/icons'
import { ExportOperationModal } from '@/components/table/operations/export-operations'

export const Route = createFileRoute(
  '/_home/meter-connection-settings/meter-size-rates/',
)({
  component: MeterSizeRatesPage,
})

function MeterSizeRatesPage() {
  const [showExportModal, setShowExportModal] = React.useState<boolean>(false)

  const {
    data: meterSizeRates,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["metersizerates"],
    queryFn: () => getMeterSizeRates(),
  })

  const contentRef = React.useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({ contentRef })

  return (
    <main className="space-y-4 p-4">
      <Header>Meter Size Rates</Header>
      <div ref={contentRef} className="print:p-2 grid grid-cols-1 md:items-stretch">
        <DataTable
          columns={meterSizeRatesColumns}
          data={meterSizeRates?.results ?? []}
          search={{
            field: "meter_size",
            label: "Meter Size",
          }}
          isLoading={isLoading}
          isError={isError}
        >
          <div className="flex w-full justify-end">
            <AddMeterSizeRates />
            <Button
              onClick={(e) => reactToPrintFn()}
              variant="outline"
              className="mx-1 bg-primary text-white hover:bg-primary hover:text-white print:hidden"
            >
              <Icons.download className="mr-2 h-4 w-4" />
              Print Meter Size Rates
            </Button>
            <ExportOperationModal
              tableData={meterSizeRates?.results ?? [{}]}
              fileName="Meter Size Rates"
              showExportModal={showExportModal}
              setShowExportModal={setShowExportModal}
            />
          </div>
        </DataTable>
        
      </div>
    </main>
  )
}